// Only the server's separate Sources: text uses Markdown links. Ordinary chat
// prose stays literal, and React escapes both the labels and unparsed text.
export const parseChatSourceLinks = (text) => {
    if (typeof text !== 'string') return [];
    if (!text.startsWith('Sources:')) return [{ text }];

    const parts = [];
    const links = /\[([^[\]\r\n]{1,240})\]\((https:\/\/[^\s)]+)\)/gi;
    let cursor = 0;
    for (const match of text.matchAll(links)) {
        let safe = false;
        try {
            const url = new URL(match[2]);
            safe = url.protocol === 'https:' && Boolean(url.hostname) && !url.username && !url.password;
        } catch {
            // An invalid destination remains visible as ordinary text.
        }
        if (!safe) continue;
        if (match.index > cursor) parts.push({ text: text.slice(cursor, match.index) });
        parts.push({ text: match[1], href: match[2] });
        cursor = match.index + match[0].length;
    }
    if (cursor < text.length || !parts.length) parts.push({ text: text.slice(cursor) });
    return parts;
};
